import script from "./legoDashboardExtend.vue?vue&type=script&lang=js"
export * from "./legoDashboardExtend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/lego/extend/legoDashboardExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e40b074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e40b074', __exports__)) {
    api.reload('0e40b074', __exports__)
  }
  
}


export default __exports__